<template>
  <panel :title="detailsSizeGrid" :withBody="true" :withFooter="true">
    <div slot="header-right">
      <span><strong>ID: </strong>{{ this.sizeGrid.code }}</span><br>
      <span><strong>Conta: </strong>{{ this.sizeGrid.account }}</span>
    </div>
    <div>
      <span><strong>Domínio: </strong>{{ this.sizeGrid.domain }}</span><br>
      <span><strong>Gênero: </strong>{{  this.sizeGrid.gender.name }}</span>
    </div>
    <div class="actions">
      <button class="btn btn--danger" @click="openDeleteModal()">Apagar</button>
    </div>
  </panel>
</template>

<script>
  import Panel from '@/components/template/Panel'

  export default {
    props: {
      sizeGrid: {
        type: Object,
        required: true
      }
    },
    computed: {
      detailsSizeGrid () {
        return `${this.sizeGrid.name}`
      }
    },
    methods: {
      openDeleteModal () {
        this.$emit('isOpenModal', true)
        this.$emit('getSizeGridToDelete', this.sizeGrid)
      }
    },
    components: {
      Panel
    }
  }
</script>

<style lang="sass"scoped>
  i
    color: #808080

  .form-flex
    display: inline

  .actions
    margin-top: 34px
    float: right

  .progress
    margin: 0
    -webkit-border-radius: 0
    -moz-border-radius: 0
    border-radius: 0

  .product
    border: 0

  .progress[value]::-ms-fill
    border: none
    background-color: #800080 !important

  .progress[value]::-webkit-progress-bar
    background-color: #f2f2f2

  .progress[value]::-webkit-progress-value
    background-color: #800080 !important

  .progress[value]::-moz-progress-bar
    background-color: #800080 !important
</style>



// WEBPACK FOOTER //
// Card.vue?086e6364